//**auto-generated don't edit this code**//
export enum StudentSpecialProgram {
	GiftedTalented,
	SPED,
	RTI,
	ELLESL,
	FiveOuFour,
}